import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import useColors from './useColors';
import { useScreenSizes } from './useSizes';
import useTheme from './useTheme';
const useStyles = (fn, stylesProps) => {
  const theme = useTheme();
  const colors = useColors();
  const window = useWindowDimensions();
  const sizes = useScreenSizes();
  const styled = useMemo(() => fn({
    colors,
    theme,
    stylesProps,
    window,
    sizes
  }), [fn, colors, theme, stylesProps, window, sizes]);
  return styled;
};
export default useStyles;